import { createContext, useContext } from 'react';
import type { Layer, LayerFunctionOption, LayerRequest, LayerPatchRequest } from './types';

type MutateCallbacks = {
  onSuccess?: () => void;
  onError?: (error: any) => void;
};

export type LayerOperationsContextType = {
  entityId: string;
  layers: Layer[];
  isLoading: boolean;
  error: any;
  createLayer: (
    params: { instanceTypeId: string; data: LayerRequest },
    callbacks?: MutateCallbacks
  ) => void;
  updateLayer: (
    params: { instanceTypeId: string; layerId: string; data: LayerPatchRequest },
    callbacks?: MutateCallbacks
  ) => void;
  updateLayerAsync: (params: {
    instanceTypeId: string;
    layerId: string;
    data: LayerPatchRequest;
  }) => Promise<any>;
  deleteLayer: (
    params: { instanceTypeId: string; layerId: string },
    callbacks?: MutateCallbacks
  ) => void;
  isCreating: boolean;
  isUpdating: boolean;
  isDeleting: boolean;
  layerFunctions: LayerFunctionOption[];
  isLoadingFunctions: boolean;
  onSuccess: () => void;
};

export const LayerOperationsContext = createContext<LayerOperationsContextType | null>(null);

export const useLayerOperations = () => {
  const context = useContext(LayerOperationsContext);
  if (!context) {
    throw new Error('useLayerOperations must be used within a LayerOperationsContext.Provider');
  }
  return context;
};
